import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useMediaQuery } from 'ah-common-lib/src/mediaQuery';
import FormFlowWrapper from '../common/form/FormFlowWrapper.vue';
import { useTheme } from 'ah-theme';
import { BrandingImageType } from 'ah-api-gateways';
import { ValidatedForm } from 'ah-common-lib/src/form/components';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';
import { makeFormModel, submitForm } from 'ah-common-lib/src/form/helpers';
import { emailField } from 'ah-common-lib/src/form/models';
import { getServices } from '@/app/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationLanding',
  props: {
  source: {
    type: String,
  },
  referral: {
    type: String,
  },
  clientId: {
    type: String,
  },
  individualId: {
    type: String,
  },
},
  emits: {
  'email-submitted': (_email: string, _referralId: string) => true,
},
  setup(__props, { emit }) {

const props = __props;





const mediaQuery = useMediaQuery();

const theme = useTheme();

const services = getServices();

const emailFormDef = ref<FormDefinition>({
  form: makeFormModel({
    name: 'landingEmail',
    fieldType: 'form',
    fields: [
      emailField('email', 'Email Address', {
        showRequiredMarkers: true,
      }),
    ],
  }),
  validation: null,
});

const isSmallScreen = computed(() => mediaQuery.is('mdDown'));

const splashLogoLink = computed(() => theme.val?.logos.find((l) => l.type === BrandingImageType.SPLASH_IMAGE)?.link);

function submitEmail() {
  emailFormDef.value.validation && submitForm(emailFormDef.value.validation);
  if (emailFormDef.value.validation?.$invalid === false) {
    const payload = {
      email: emailFormDef.value.form.email,
      source: props.source,
      referral: props.referral,
      clientId: props.clientId,
      individualId: props.individualId,
    };

    services.registration
      .registrationLanding(payload, {
        options: {
          errors: {
            silent: true,
          },
        },
      })
      .subscribe({
        next: (response) => {
          const referralId = response.id;
          emit('email-submitted', emailFormDef.value.form.email, referralId);
        },
      });
  }
}

return { __sfc: true,props, emit, mediaQuery, theme, services, emailFormDef, isSmallScreen, splashLogoLink, submitEmail, FormFlowWrapper, ValidatedForm }
}

})